import { useQuery } from "@tanstack/react-query";
import { Reveal } from "./Reveal";
import { RichText } from "./RichText";
import { useLang } from "@/context/LanguageContext";

// Renders admin-managed rich-text blocks for a given page + position.
// `position` = "top" | "bottom".
export function PageContentBlocks({ page, position, className = "", narrow = true }) {
  const { tl } = useLang();
  const { data: blocks = [] } = useQuery({
    queryKey: ["content-blocks", page],
    queryFn: async () => (await import("@/lib/api")).api.get(`/content-blocks?page=${encodeURIComponent(page)}`).then((r) => r.data),
    enabled: !!page,
  });

  const stripHtml = (h) => (h || "").replace(/<[^>]+>/g, " ").trim();
  const list = blocks.filter(
    (b) => (b.position || "bottom") === position && (tl(b, "title") || stripHtml(tl(b, "html")))
  );
  if (list.length === 0) return null;

  return (
    <section className={`relative z-10 py-10 sm:py-14 ${className}`} data-testid={`content-blocks-${position}`}>
      <div className={`mx-auto ${narrow ? "max-w-3xl" : "max-w-5xl"} px-5 sm:px-8 space-y-10`}>
        {list.map((b) => (
          <Reveal key={b.id}>
            <article data-testid={`content-block-${b.id}`}>
              {tl(b, "title") && (
                <h2 className="font-serif text-3xl sm:text-4xl tracking-tight text-[#0F172A] mb-4">{tl(b, "title")}</h2>
              )}
              <RichText html={tl(b, "html")} className="text-[#475569] text-base sm:text-lg leading-relaxed" />
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
